import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-speedometer-03',
  standalone: true,
  templateUrl: './rt-icon-speedometer-03.component.html',
  styleUrls: ['./rt-icon-speedometer-03.component.scss']
})
export class RtIconSpeedometer03Component {
  @Input() width: number | string = 22;
  @Input() height: number | string = 22;
}
